import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CardImage } from './CardImage';

export default function CategoryCard({ category, onClick, noImageLabel }) {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        borderRadius: 3,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        transition: 'all 0.22s ease',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: '0 10px 28px rgba(184,137,74,0.14)',
          borderColor: 'primary.light',
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{
          height: '100%',
          p: { xs: 1.25, sm: 1.5 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 1.25,
        }}
      >
        <Box
          sx={{
            width: { xs: 72, sm: 80, md: 88 },
            height: { xs: 72, sm: 80, md: 88 },
            mx: 'auto',
            flexShrink: 0,
          }}
        >
          <CardImage
            src={category.image}
            alt={category.name}
            aspectRatio="1 / 1"
            rounded="50%"
            iconSize={28}
            fit="contain"
          />
        </Box>

        <Typography
          variant="body2"
          fontWeight={700}
          align="center"
          title={category.name}
          sx={{
            width: '100%',
            lineHeight: 1.35,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: { xs: 34, sm: 38 },
          }}
        >
          {category.name}
        </Typography>

        {!category.image && (
          <Typography variant="caption" color="text.secondary" align="center" display="block">
            {noImageLabel}
          </Typography>
        )}
      </CardActionArea>
    </Card>
  );
}
